// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1PpBa","imageUploader":"EGiftCard_imageUploader__2bXl4"};